import { create } from 'zustand'

export interface IGameRuleStore {
  isOpened: boolean
}

export const useGameRuleStore = create<IGameRuleStore>(() => ({
  isOpened: false,
}))
